<template id="property-page">
  <slot
    name="content"
    :openFullGalleryView="openFullGalleryView"
    :index="index"
    :closeLightBox="closeLightBox"
    :controls="controls"
    :isReadMore="isReadMore"
    :triggerReadMore="triggerReadMore"
    :togglePropertyEnquiryForm="togglePropertyEnquiryForm"
    :showManagerNumberButton="showManagerNumberButton"
    :showManagerNumberId="showManagerNumberId"
    :isMobile="isMobile"
    :showPropertyListModal="showPropertyListModal"
    :toggleModal="toggleModal"
    :clickTile="clickTile"
    ></slot>
</template>

<script setup>
import {ref, defineProps, nextTick, onMounted} from 'vue'
import useGlobalStore from '../../store/globalStore'
import {useCommon} from '../../composables/useCommon'
import {useFormSubmit} from '../../composables/useFormSubmit'

const index = ref(null);
const globalStore = useGlobalStore()
const { openFullGalleryView, triggerReadMore, showManagerNumberButton, showManagerNumberId, closeLightBox, isReadMore } = useCommon(index)
const { showPropertyListModal, toggleModal, clickTile } = useFormSubmit()

const props = defineProps({
  propertyEnquiryTitle: {
    type: String,
    default: '',
  },
  dataLayerData: {
    type: Object,
    default: () => [],
  },
  propertyPriceEnquiryTitle: {
    type: String,
    default: '',
  },
});

const showEnquiryId = ref(false);
const controls = ref([
  '<i class=\'icon icon--arrow-left\'></i>',
  '<i class=\'icon icon--arrow-right\'></i>'
]);
const isMobile = ref(false);

// methods
const showPropertyInfo = (propertyId) => {
  let url = `${window.location.protocol}//${window.location.host}/`;
  const pathArray = window.location.pathname.split('/');
  url = `${url}${pathArray[1]}/${pathArray[2]}/${propertyId}/property-info`;
  history.pushState(null, null, url);
  store.commit('setModal', `property_${propertyId}`);
};

const togglePropertyEnquiryForm = async (propertyId, title, e) => {
  globalStore.setModal(
    {
      name: 'propertyEnquiryModal',
      title: `Enquiry about <br> <span>${title}</span>`,
      showFooter: false,
    }
  )

  if (showEnquiryId.value === propertyId) {
    showEnquiryId.value = false;
  } else {
    showEnquiryId.value = propertyId;
  }

  await nextTick()

  const ele = e.target;
  const form = document.getElementById('village-common-enquiry-form');

  if (form) {
    form.querySelector('.enquiry_type_full').value = ele.dataset.enquiryTypeFull;
  }
};

// created lifecycle hook
onMounted(async () => {
  if (window.innerWidth <= 991 ) {
    isMobile.value = true
  }

  await nextTick()

  // if (showPropertyInfoId.value) {
  //   showPropertyInfo(showPropertyInfoId.value);
  // }

  // Update the google tag manager event.
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  window.dataLayer.push(props.dataLayerData);

  let currentUrl = window.location.href;

  if (currentUrl.includes('#enquiry-pricing')) {
    globalStore.setModal(
      {
        name: 'propertyListEnquiryModal',
        title: props.propertyPriceEnquiryTitle,
        showFooter: false,
      }
    )
  } else if (currentUrl.includes('#enquiry')) {
    globalStore.setModal(
      {
        name: 'propertyEnquiryModal',
        title: props.propertyEnquiryTitle,
        showFooter: false,
      }
    )
  }
});

</script>
